














































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbCard, mdbView, mdbCardBody, mdbMask, mdbIcon, mdbRow, mdbCol, mdbPopover, mdbBtn } from '@folky-tools/mdbvue';
import { BusinessInteractionStatusKpi } from '@/models/kpis/business-interactions-status-kpi';
import { BusinessTotalInteractionsKpi, InteractionType } from '@/models/kpis/business-interactions-total-kpi';
import { kpisService, getOrganizationBusinessFrontPageSummaryByBusinessId } from '@/services';
import { BusinessFrontPageSummary } from '@/models/businesses/business-front-page-summary';
import * as moment from 'moment';

@Component({ components: { mdbCard, mdbCardBody, mdbView, mdbMask, mdbIcon, mdbRow, mdbCol, mdbPopover, mdbBtn } })
export default class BusinessVisitsStatus extends Vue {
    @Prop({ type: Number, required: true }) private readonly businessId!: number;
    private businessFrontPageSummary: BusinessFrontPageSummary | null = null;
    private businessInteractionsStatusKpi: BusinessInteractionStatusKpi = new BusinessInteractionStatusKpi();
    private businessInteractions: BusinessTotalInteractionsKpi[] = [];
    private aggregatedBusinessInteractions: number = 0;
    private pageContentLoaded: boolean = false;
    private userBusinessVisitViewChartData: any[][] = [];
    private userBusinessVisitViewChartOptions: any = {
        curveType: '',
        legend: { position: 'top' },
        lineWidth: 4,
        vAxis: { minValue: 0 },
        height: 400
    };
    private userBusinessInteractionChartData: any[][] = [];
    private userBusinessInteractionChartOptions: any = {
        isStacked: true,
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: '75%' },
        vAxis: { minValue: 0 },
        height: 400
    };
    private isViewsDataVisible: boolean = false;

    private async created(): Promise<void> {
        this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(this.businessId));
        this.businessInteractionsStatusKpi = await kpisService.getBusinessInteractionStatusKpi(this.businessId);
        this.businessInteractions = this.businessInteractionsStatusKpi.last30DaysTotalInteractions.filter(i => i.count! > 0).sort((a, b) => b.count! - a.count!);
        this.aggregatedBusinessInteractions = this.businessInteractions.reduce((a, i) => {
            return a + i.count!;
        }, 0);
        this.getVisitViewsChartData();
        this.getInteractionsChartData();
        this.pageContentLoaded = true;
        setTimeout(() => this.$emit('businessVisitStatusLoaded'), 1500);
    }

    private getInteractionType(interaction: any) {
        switch (interaction) {
            case 0:
                return 'totalContactsPhoneCount';
            case 1:
                return 'totalContactsEmailCount';
            case 2:
                return 'totalContactsWhatsappCount';
            case 3:
                return 'totalLocationsMapCount';
            case 4:
                return 'totalVisitsFacebookCount';
            case 5:
                return 'totalVisitsInstagramCount';
            case 6:
                return 'totalVisitsTwitterCount';
            case 7:
                return 'totalVisitsYoutubeCount';
            case 8:
                return 'totalVisitsPinterestCount';
            case 9:
                return 'totalVisitsLinkedinCount';
            case 10:
                return 'totalVisitsMyWebsiteCount';
            case 11:
                return 'totalVisitsTikTokCount';
            case 12:
                return 'totalVisitsTelegramCount';
            case 13:
                return 'totalSharedCount';
            case 14:
                return 'totalSavedContactCount';
            case 15:
                return 'totalReadsQRCodeCount';
            case 16:
                return 'totalClicksToUserContentLinksCount';
            case 17:
                return 'totalVisitsMyOnlineShopCount';
            default:
                return 'totalReadsQRCodeCount';
        }
    }

    private getVisitViewsChartData() {
        this.isViewsDataVisible =
            this.businessFrontPageSummary !== null &&
            (this.businessFrontPageSummary.publicationStatus.length > 1 || !(this.businessFrontPageSummary.publicationStatus[0].organizationId === 1 && this.businessFrontPageSummary.publicationStatus[0].consumerId === 4));

        for (let i = 0; i <= this.businessInteractionsStatusKpi.last30DaysDailyData.length; i++) {
            this.userBusinessVisitViewChartData.push([]);
        }

        this.userBusinessVisitViewChartData[0][0] = this.$t('components.businesses.visitsViewsStatus.graph.days').toString();
        this.userBusinessVisitViewChartData[0][1] = this.$t('components.businesses.visitsViewsStatus.graph.visits').toString();
        if (this.isViewsDataVisible) {
            this.userBusinessVisitViewChartData[0][2] = this.$t('components.businesses.visitsViewsStatus.graph.views').toString();
        }

        this.businessInteractionsStatusKpi.last30DaysDailyData.forEach((day, index) => {
            this.userBusinessVisitViewChartData[index + 1][0] = moment.utc(day.dateUtc).local().format('DD/MM');
            this.userBusinessVisitViewChartData[index + 1][1] = day.totalUsersCount;
            if (this.isViewsDataVisible) {
                this.userBusinessVisitViewChartData[index + 1][2] = day.totalImpresionsCount;
            }
        });
        setTimeout(() => this.$emit('businessVisitStatusLoaded'), 1000);
    }

    private getInteractionsChartData() {
        for (let i = 0; i <= this.businessInteractionsStatusKpi.last30DaysDailyData.length; i++) {
            this.userBusinessInteractionChartData.push([]);
        }

        this.userBusinessInteractionChartData[0][0] = this.$t('components.businesses.visitsViewsStatus.graph.days').toString();
        this.businessInteractions.forEach((interaction, index) => {
            this.userBusinessInteractionChartData[0][index + 1] = this.$t('components.businesses.visitsViewsStatus.graph.' + interaction.interaction).toString();
        });

        this.businessInteractionsStatusKpi.last30DaysDailyData.forEach((day, index) => {
            this.userBusinessInteractionChartData[index + 1][0] = moment.utc(day.dateUtc).local().format('DD/MM');
            this.businessInteractions.forEach((interaction, interactionIndex) => {
                this.userBusinessInteractionChartData[index + 1][interactionIndex + 1] = day[this.getInteractionType(interaction.interaction)];
            });
        });
        setTimeout(() => this.$emit('businessVisitStatusLoaded'), 1000);
    }
}
